import {  ChangeDetectionStrategy, Component, EventEmitter, Output, input } from '@angular/core';
import { Transforms } from '@app/shared';

@Component({
    selector: 'form-dialog-standard-submit-buttons',
    templateUrl: './form-dialog-standard-submit-buttons.component.html',
    styleUrl: './form-dialog-standard-submit-buttons.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormDialogStandardSubmitButtonsComponent {
  
  public actionButtonName = input<string>(null);  
  public applyButtonName = input<string>(null); 
  public closeBtnName = input<string>(null);

  public cancelCss = input<string>(null);  
  public applyCss = input<string>(null); 
  public submitCss = input<string>(null);
  
  public enableSubmitButton = input(true, {
    transform: Transforms.toBoolean
  });
  public enableApplyButton = input(false, {
    transform: Transforms.toBoolean
  });

  public enableCancelButton = input(true, {
    transform: Transforms.toBoolean
  });
  
  public isValid = input<boolean>(true);
  public isBusy = input<boolean>(false);
  
  @Output() 
  public submit = new EventEmitter();

  @Output()
  public apply = new EventEmitter();

  @Output() 
  public cancel = new EventEmitter();
    
  public cancelClicked() {
    this.cancel.emit();
  }

  public submitClicked() {
    this.submit.emit();    
  }

  public applyClicked() {
    this.apply.emit();
  }

}